import React, { useState } from 'react';
import { Panel, PanelBorderRadius, PanelTheme } from '@apply/components';

import { ExperienceViewRadioGroup } from './components/ExperienceViewRadioGroup';
import { ProvidedGuidanceMessage } from './components/ProvidedGuidanceMessage';
import { ActiveExperienceViewType } from '../../constants/ActiveExperienceViewType';
import { NonBFIPanel } from './components/NonBFIPanel/NonBFIPanel';
import { BFITable } from './components/BFIPanel/components/BFITable';
import { ContingencyNotificationMessage } from './components/ContingencyNotificationMessage';
import { UserExperienceDto } from '@apply/api/src/api/ApplyApi';
import { isMobileScreen } from '@apply/ui';

export interface ExperiencePanelProps {
    unverifiedExperience: UserExperienceDto[];
    verifiedExperience: UserExperienceDto[];
}

export const ExperiencePanel: React.FC<ExperiencePanelProps> = ({ unverifiedExperience, verifiedExperience }) => {
    const mobileScreen = isMobileScreen();
    const [experienceViewType, set_experienceViewType] = useState(ActiveExperienceViewType.NonBFIExperience);

    return (
        <>
            <Panel
                theme={PanelTheme.White}
                borderRadius={PanelBorderRadius.Medium}
            >
                <div className={`experience-navigationSection ${mobileScreen ? 'mobile' : ''}`}>
                    <div className={`experience-levelDirections ${mobileScreen ? 'mobile' : ''}`}>
                        <ProvidedGuidanceMessage
                            unverifiedExperience={unverifiedExperience}
                            verifiedExperience={verifiedExperience}
                        />
                    </div>

                    <div className={`experience-navigationalButtons ${mobileScreen ? 'mobile' : ''}`}>
                        <ExperienceViewRadioGroup
                            experienceViewType={experienceViewType}
                            onValueChanged={set_experienceViewType}
                        />
                    </div>
                </div>
                {experienceViewType == ActiveExperienceViewType.NonBFIExperience && (
                    <NonBFIPanel
                        verifiedExperience={verifiedExperience}
                        unverifiedExperience={unverifiedExperience}
                    />
                )}
                {experienceViewType == ActiveExperienceViewType.BFIExperience && <BFITable experiences={verifiedExperience} />}
                <br />
                <ContingencyNotificationMessage />
            </Panel>
        </>
    );
};
